var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOftalmologico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_141",
    "data-name": "Rect\\xE1ngulo 141",
    width: 59,
    height: 59,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1503",
    "data-name": "Grupo 1503",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_425",
    "data-name": "Trazado 425",
    d: "M0,0V12.1H3.47V3.434h8.588V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_426",
    "data-name": "Trazado 426",
    d: "M0,293.01v12.1H12.1v-3.465H3.444V293.01Z",
    transform: "translate(0 -246.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_427",
    "data-name": "Trazado 427",
    d: "M301.636,293.3v8.624h-8.625v3.429h12.1V293.3Z",
    transform: "translate(-246.111 -246.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1502",
    "data-name": "Grupo 1502",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1501",
    "data-name": "Grupo 1501",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_428",
    "data-name": "Trazado 428",
    d: "M.341,102.234c4.345-4.6,8.537-9.237,14.294-12.1A33.825,33.825,0,0,1,53.5,96.3c1.938,1.914,3.8,3.9,5.713,5.868a1.271,1.271,0,0,1-.133.218c-2.206,2.246-4.314,4.6-6.642,6.713a32.58,32.58,0,0,1-20.353,8.672c-10.505.648-19.41-2.964-26.794-10.408-1.662-1.675-3.281-3.392-4.955-5.125M29.783,89.991a12.223,12.223,0,1,0,12.227,12.233A12.235,12.235,0,0,0,29.783,89.991m12.584,21.655c4.01-1.682,9.736-6.184,12.046-9.442-3.426-3.864-7.174-7.312-12.037-9.407,4.119,6.3,4.115,12.54-.008,18.849M17.2,111.633c-4.113-6.314-4.12-12.546,0-18.837C12.323,94.9,8.573,98.35,5.157,102.214c3.424,3.877,7.176,7.308,12.04,9.418",
    transform: "translate(-0.286 -72.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_429",
    "data-name": "Trazado 429",
    d: "M305.334.335V12.329h-3.41V3.756H293.3V.335Z",
    transform: "translate(-246.357 -0.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_430",
    "data-name": "Trazado 430",
    d: "M159.015,159.064v3.425h-3.4v-3.4h-3.456v-3.445h3.411v-3.425h3.424v3.4h3.455v3.445Z",
    transform: "translate(-127.801 -127.854)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOftalmologico);
export default __webpack_public_path__ + "static/media/oftalmologico.8c8f3d1f009c6ad5d6d62fd5e34cd52d.svg";
export { ForwardRef as ReactComponent };